import { StringSchema } from 'yup'

export default function plate(this: StringSchema, message: string) {
  return this.test('plate', message, (maskedPlate = '') => {
    const plateWithoutMask = maskedPlate.replace(/[.-]/g, '')
    const hasSevenDigits = plateWithoutMask.length === 7
    const regexPlate = /^[a-zA-Z]{3}[0-9]{4}$/
    const regexPlateMercosul = /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$/
    const isPlateValid = regexPlate.test(plateWithoutMask)
    const isMercosulPlateValid = regexPlateMercosul.test(plateWithoutMask)
    return hasSevenDigits && (isPlateValid || isMercosulPlateValid)
  })
}
